<template>
  <v-dialog :value="show" :max-width="maxWidth" persistent @input="$emit('update:show', $event)">
    <div class="cd-dialog">
      <div class="cd-dialog__header" :class="`cd-dialog__header--${type}`">
        <div class="cd-dialog__icon-wrap">
          <v-icon size="20" color="white">{{ iconMap[type] }}</v-icon>
        </div>
        <h2 class="cd-dialog__title">{{ title }}</h2>
      </div>

      <div class="cd-dialog__body">
        <p class="cd-dialog__message">
          {{ message }}
          <strong v-if="itemName"> "{{ itemName }}"</strong>
          <span v-if="message && !itemName">.</span>
        </p>
        <p v-if="type === 'danger'" class="cd-dialog__sub">This action cannot be undone.</p>
      </div>

      <div class="cd-dialog__footer">
        <button class="ec-btn ec-btn--ghost" :disabled="loading" @click="onCancel">
          {{ cancelText }}
        </button>
        <button class="ec-btn" :class="btnClass" :disabled="loading" @click="onConfirm">
          <v-progress-circular v-if="loading" size="13" width="2" indeterminate style="margin-right:6px" />
          {{ confirmText }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  model: { prop: 'show', event: 'update:show' },
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Are you sure?' },
    message: { type: String, default: '' },
    itemName: { type: String, default: '' },
    confirmText: { type: String, default: 'Confirm' },
    cancelText: { type: String, default: 'Cancel' },
    type: { type: String, default: 'danger', validator: v => ['danger', 'warning', 'info'].includes(v) },
    loading: { type: Boolean, default: false },
    maxWidth: { type: [String, Number], default: 400 }
  },
  computed: {
    iconMap () {
      return { danger: 'mdi-delete-outline', warning: 'mdi-alert-outline', info: 'mdi-information-outline' }
    },
    btnClass () {
      return {
        danger: 'ec-btn--danger',
        warning: 'ec-btn--warning',
        info: 'ec-btn--info'
      }[this.type] || 'ec-btn--danger'
    }
  },
  methods: {
    onConfirm () { this.$emit('confirm') },
    onCancel () { this.$emit('cancel'); this.$emit('update:show', false) }
  }
}
</script>

<style scoped>
.cd-dialog {
  background: var(--ec-surface);
  border-radius: var(--ec-radius);
  overflow: hidden;
}
.cd-dialog__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
}
.cd-dialog__header--danger  { background: var(--ec-danger-bg);  border-bottom: 1px solid #fecaca; }
.cd-dialog__header--warning { background: var(--ec-warning-bg); border-bottom: 1px solid #fde68a; }
.cd-dialog__header--info    { background: var(--ec-info-bg);    border-bottom: 1px solid #bfdbfe; }

.cd-dialog__icon-wrap {
  width: 34px; height: 34px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.cd-dialog__header--danger  .cd-dialog__icon-wrap { background: var(--ec-danger); }
.cd-dialog__header--warning .cd-dialog__icon-wrap { background: var(--ec-warning); }
.cd-dialog__header--info    .cd-dialog__icon-wrap { background: var(--ec-info); }

.cd-dialog__title {
  font-size: .95rem; font-weight: 700; margin: 0;
}
.cd-dialog__header--danger  .cd-dialog__title { color: var(--ec-danger); }
.cd-dialog__header--warning .cd-dialog__title { color: var(--ec-warning); }
.cd-dialog__header--info    .cd-dialog__title { color: var(--ec-info); }

.cd-dialog__body {
  padding: 20px 20px 8px;
}
.cd-dialog__message {
  font-size: .88rem;
  color: var(--ec-text-2);
  margin: 0 0 6px;
  line-height: 1.5;
}
.cd-dialog__sub {
  font-size: .78rem;
  color: var(--ec-text-3);
  margin: 0;
}
.cd-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid var(--ec-border-light);
}

/* Vuetify override for warning/info buttons (admin.css only has danger) */
.ec-btn--warning { background: var(--ec-warning); color: #fff; }
.ec-btn--warning:hover:not(:disabled) { background: #b45309; }
.ec-btn--info    { background: var(--ec-info); color: #fff; }
.ec-btn--info:hover:not(:disabled)    { background: #1d4ed8; }
</style>
